import React from 'react';
import {__GPYSmallInit,__GPYPost,__GPYGet} from '../env.js'

class GuppyiI18n extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        i18n_A:{},
        i18n_B:{},
        i18n_C:{},
        currentLang:(navigator.language || navigator.userLanguage || "en-UK").split("-")[0],
        edit:"",
      	language: [],

        filter: "",
        _filter: "",
      };

      __GPYSmallInit(()=>{
        __GPYGet("getAllowedLanguages",(result) => {
            this.setState({language: result});

            __GPYPost('getI18nValues',{locale:"de"},(result) => {
                this.setState({i18n_A:result.i18n.values});
            });
            __GPYPost('getI18nValues',{locale:"en"},(result) => {
                this.setState({i18n_B:result.i18n.values});
            });
            __GPYPost('getI18nValues',{locale:this.state.currentLang},(result) => {
                this.setState({i18n_C:result.i18n.values});
            }
            );

          }
          , (error) => {
            this.setState({language:[]});
          }
        );

      });

  }

  onChangeLang(e){
    this.setState({currentLang:e.target.value},() => {
      __GPYPost('getI18nValues',{locale:this.state.currentLang},(r) => {
          this.setState({i18n_C: r.i18n.values});
      });
    });
  }


  save(key){
      __GPYPost('changeI18nValue', {key:key, lang:this.state.currentLang, value:this.state.i18n_C[key]},(r)=>{
          this.setState({edit:"."});
      } );
  	}

  doFilter(k){
    var filter = this.state._filter;
    if ( filter === "" ) {
      return true;
    }

    var key = k+" "+this.state.i18n_A[k]+" "+this.state.i18n_B[k]+" "+this.state.i18n_C[k];
    return key.toLowerCase().includes(filter);
  }

  changeActiveKey(key) {
    this.setState({edit:key});
  }

  onChangeFilter(e){
      this.setState({filter:e.target.value,_filter:e.target.value.toLowerCase()});
  }

  render() {
    const {i18n_A,i18n_B,i18n_C,edit,language} = this.state;
    return (
      <div className='container-fluid p-0'>
        <div className="row bg-secondary">
          <div className="col-12">
             <div className="row p-3">
               <div className="col-4"><h3>DE</h3></div>
               <div className="col-4"><h3>EN</h3></div>
               <div className="col-4">
               <div className="form-group">
                   <label htmlFor="exampleFormControlSelect1">Choose your language</label>
                   <select className="form-control" id="exampleFormControlSelect1" value={this.state.currentLang} onChange={this.onChangeLang.bind(this)}>
                    {language.map((i) => {
                          return (<option value={i.Locale.localeString}>{i.Locale.displayLang}</option>)
                      })
                    }
                   </select>
                 </div>

               </div>
              </div>

              <div className="col-12">
                  <div className="input-group mb-3">
                    <input type="text" class="form-control" value={this.state.filter} placeholder="search" aria-describedby="button-addon2" onChange={this.onChangeFilter.bind(this)}/>
                  </div>
              </div>
      </div>
    </div>

    <div className="row p-0">
      <div className="col-12">
          {Object.keys(i18n_A).filter( (k)=>{ return this.doFilter(k) } ).sort().map((k) => {
               return (
                 <ul className="list-group list-group-flush">
                 <li className="list-group-item">
                  <div className="row">
                   <div className="col-12 p-3 text-monospace text-muted border-bottom border-light" style={{fontSize:"12px"}}>{k}</div>
                   </div>
                  <div className="row">
                   <div className="col-4 p-3">{i18n_A[k]}</div>
                   <div className="col-4 p-3" style={{overflow:"hidden"}}>{i18n_B[k]}</div>
                   <div className="col-4 p-3" style={{overflow:"hidden"}}>
                   { edit === k ?

                     <div className="form-group">
                        <textarea className="form-control" id="exampleFormControlTextarea1" onChange={(e)=>{i18n_C[k] = e.target.value}}rows="3">
                        {i18n_C[k]}
                        </textarea>
                        <button onClick={this.save.bind(this,k)} className="btn btn-primary">Save</button>
                        <button onClick={this.changeActiveKey.bind(this,".")} className="btn btn-secondery">Cancel</button>
                    </div>

                   :
                      <span> {i18n_C[k]!==undefined&&i18n_C[k]!==''?i18n_C[k]:"..."}
                      <br/><button onClick={this.changeActiveKey.bind(this,k)} className="btn btn-light"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span></button>
                      </span>
                   }
                   </div>
                  </div>
                </li>
                </ul>
                      );
             })
          }

          </div>
         </div>
      </div>
    );
  }
}

export default GuppyiI18n;
